/**
 * 天气api
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 获取城市天气
	 * @param{cityId} 城市代码
	 */
	getWeatherData(cityId,success, failure) {
		Axios.post('/weather/getWeatherData.do', {
			cityId
		}, success, failure)
	},
}